/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import MainDashboard from '../components/dashboards/MainDashboard';
import styles from '../styles/Home.module.css';


const Dashboard = () => {
  
  return (
    <>
    <div className="bannerAuth"  >
        <div className="leftbanner" >{" US and Non-US Persons "}</div >
        <div className="spanCenter">Technical Data<a  style={{textDecoration:'none', color:'#000'}} href="https://rtxusers.sharepoint.us/sites/enghub-PW/_layouts/15/settings.aspx">/</a>Information&nbsp;<strong>Strictly Prohibited</strong></div>
        <div className="rightbanner" >{" US and Non-US Persons "}</div >
    </div>
    <div className={styles.protectPage_title_container}>
    <div className={styles.protectPage_title}>Portal Registration</div>
  </div>
  <main className={styles.protectedMain} > 
  <div className={styles.mainDivStyle}>
    <MainDashboard />
  </div>
    </main>
    </>
    
  );
};

export default Dashboard;
